<template>
    <div class="article-contact">
        <p>
            {{ $config.public.siteName }} is committed to letting people know about West Coast Swing. We'd love to help:
        </p>
        <ul>
            <li>Broadcast your event</li>
            <li>Raise your dancer profile</li>
            <li>List your class on the map</li>
        </ul>
        <p><em>Drop us a message</em> - let's talk!</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
